import React from 'react'
import { i18n } from '../../index'
import { alphaSort } from '../../../common/utils'
import { Paper, Table, TableBody } from '@mui/material'
import MarketQuestionRow from './MarketQuestionRow'
import type { MarketQuestion } from './marketQuestionTypes'
import css from './marketQuestionTable.css'
type MarketQuestionTableProps = {
  data: Array<MarketQuestion>
  onEdit: (...args: Array<any>) => any
}

class MarketQuestionTable extends React.PureComponent<MarketQuestionTableProps> {
  render() {
    const { data, onEdit } = this.props
    return (
      <Paper>
        <div className={css.component}>
          <Table>
            <TableBody>
              {data.length ? (
                alphaSort('description', data).map((mq) => (
                  <MarketQuestionRow data={mq} onEdit={onEdit} key={mq.description} />
                ))
              ) : (
                <p className={css.empty}>{i18n.t('admin.marketQuestion.noItems')}</p>
              )}
            </TableBody>
          </Table>
        </div>
      </Paper>
    )
  }
}

export default MarketQuestionTable
